// public const ROLE_CAN_VIEW_SESSIONS = 'ROLE_CAN_VIEW_SESSIONS';
// public const ROLE_CAN_MANAGE_TARIFFS = 'ROLE_CAN_MANAGE_TARIFFS';
// public const ROLE_CAN_DELETE_TARIFFS = 'ROLE_CAN_DELETE_TARIFFS';
// public const ROLE_CAN_MANAGE_STATIONS = 'ROLE_CAN_MANAGE_STATIONS';
// public const ROLE_CAN_DELETE_STATIONS = 'ROLE_CAN_DELETE_STATIONS';
// public const ROLE_CAN_MANAGE_LOCATIONS = 'ROLE_CAN_MANAGE_LOCATIONS';
// public const ROLE_CAN_DELETE_LOCATIONS = 'ROLE_CAN_DELETE_LOCATIONS';
// public const ROLE_CAN_MANAGE_CUSTOMERS = 'ROLE_CAN_MANAGE_CUSTOMERS';
// public const ROLE_CAN_DELETE_CUSTOMERS = 'ROLE_CAN_DELETE_CUSTOMERS';
// public const ROLE_CAN_MANAGE_USERS = 'ROLE_CAN_MANAGE_USERS';
// public const ROLE_CAN_ACCESS_SYSTEM_LOGS = 'ROLE_CAN_ACCESS_SYSTEM_LOGS';
// public const ROLE_CAN_MANAGE_PAYOFFS = 'ROLE_CAN_MANAGE_PAYOFFS';
// public const ROLE_CAN_MANAGE_EMPLOYEES = 'ROLE_CAN_MANAGE_EMPLOYEES';
// public const ROLE_CAN_DELETE_EMPLOYEES = 'ROLE_CAN_DELETE_EMPLOYEES';
// public const ROLE_CAN_MANAGE_INVOICES = 'ROLE_CAN_MANAGE_INVOICES';

export enum UserRoles {
    ROLE_CAN_VIEW_SESSIONS = "ROLE_CAN_VIEW_SESSIONS",
    ROLE_CAN_MANAGE_TARIFFS = "ROLE_CAN_MANAGE_TARIFFS",
    ROLE_CAN_DELETE_TARIFFS = "ROLE_CAN_DELETE_TARIFFS",
    ROLE_CAN_MANAGE_STATIONS = "ROLE_CAN_MANAGE_STATIONS",
    ROLE_CAN_DELETE_STATIONS = "ROLE_CAN_DELETE_STATIONS",
    ROLE_CAN_MANAGE_LOCATIONS = "ROLE_CAN_MANAGE_LOCATIONS",
    ROLE_CAN_DELETE_LOCATIONS = "ROLE_CAN_DELETE_LOCATIONS",
    ROLE_CAN_MANAGE_CUSTOMERS = "ROLE_CAN_MANAGE_CUSTOMERS",
    ROLE_CAN_DELETE_CUSTOMERS = "ROLE_CAN_DELETE_CUSTOMERS",
    ROLE_CAN_MANAGE_EMPLOYEES = "ROLE_CAN_MANAGE_EMPLOYEES",
    ROLE_CAN_DELETE_EMPLOYEES = "ROLE_CAN_DELETE_EMPLOYEES",
    ROLE_CAN_MANAGE_PAYOFFS = "ROLE_CAN_MANAGE_PAYOFFS",
    ROLE_CAN_MANAGE_USERS = "ROLE_CAN_MANAGE_USERS",
    ROLE_CAN_ACCESS_SYSTEM_LOGS = "ROLE_CAN_ACCESS_SYSTEM_LOGS",
    ROLE_CAN_MANAGE_INVOICES = "ROLE_CAN_MANAGE_INVOICES",
}

export const userRolesCharging = [
    UserRoles.ROLE_CAN_VIEW_SESSIONS,
    UserRoles.ROLE_CAN_MANAGE_TARIFFS,
    UserRoles.ROLE_CAN_DELETE_TARIFFS,
];

export const userRolesAssets = [
    UserRoles.ROLE_CAN_MANAGE_STATIONS,
    UserRoles.ROLE_CAN_DELETE_STATIONS,
    UserRoles.ROLE_CAN_MANAGE_LOCATIONS,
    UserRoles.ROLE_CAN_DELETE_LOCATIONS,
];

export const userRolesCustomers = [
    UserRoles.ROLE_CAN_MANAGE_CUSTOMERS,
    UserRoles.ROLE_CAN_DELETE_CUSTOMERS,
];

export const userRolesEmployees = [
    UserRoles.ROLE_CAN_MANAGE_EMPLOYEES,
    UserRoles.ROLE_CAN_DELETE_EMPLOYEES,
    UserRoles.ROLE_CAN_MANAGE_PAYOFFS,
];

export const userRolesManagement = [
    UserRoles.ROLE_CAN_MANAGE_USERS,
    UserRoles.ROLE_CAN_ACCESS_SYSTEM_LOGS,
];

export const userRoleBilling = [UserRoles.ROLE_CAN_MANAGE_INVOICES];
